import odata from 'odata-client';
import {
  UPDATE_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_ERROR,
  UPDATE_EMPLOYEE_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

export const updateEmployeeRequest = () => ({
  type: UPDATE_EMPLOYEE_REQUEST
});

export const updateEmployeeError = errorOrResults => ({
  type: UPDATE_EMPLOYEE_ERROR,
  error: errorOrResults.message
});

export const updateEmployeeSuccess = payload => ({
  type: UPDATE_EMPLOYEE_SUCCESS,
  payload
});

export default (employee, employeeTableData) => async (dispatch, getState) => {
  if (!(employee.LastName) || employee.LastName.trim() === "" /*|| !(employee.FirstNames) || employee.FirstNames.trim() === ""*/ || !(employee.Organisation.ID)) {
    dispatch(showNotification("Required fields must NOT be empty", "error"))
    return new Error()
  }

  dispatch(updateEmployeeRequest());

  let patchObj = employee
  patchObj = {
    ...patchObj,
    Organisation: { ID: patchObj.Organisation.ID }
  }
  if (patchObj.Crew && patchObj.Crew.ID) {
    patchObj = { ...patchObj, Crew: { ID: patchObj.Crew.ID } }
  }

  const query = odata({ service: getServiceUrl() }).resource(RESOURCES.Employees, employee.ID);
  const errorOrResult = await query.patch(patchObj, {
    headers: {
      Authorization: `Bearer ${getState().user.token}`,
      ...getDefaultHeader()
    }
  })
    .then(resp => resp)
    .then(res => {
      const ok = res.statusCode <= 299 && res.statusCode >= 200;

      if (res.statusCode === 500) {
        const errorKey = "GENERAL_SERVER_ERROR";
        return new Error(errorKey);
      } else if (!ok) {
        const response = res.toJSON()
        const error = JSON.parse(response.body).Error
        const errorKey = res.statusCode === 401 ? `401: ${error.Details[0].Message}` : `${error.Code}`;
        console.log("update employee api error", response);
        return new Error(errorKey);
      } else {
        const payload = employee;
        payload.tableData = employeeTableData;
        return payload;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      dispatch(showNotification("Request probably timed out.", "error"))
    });

  if (errorOrResult instanceof Error) {
    dispatch(updateEmployeeError(UPDATE_EMPLOYEE_ERROR, errorOrResult.message));
    if (errorOrResult.message.split(":")[0] === "401") {
      dispatch(tokenExpired());
      dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
    }
    console.log("CODE ERROR: ", errorOrResult.message);
    if (errorOrResult.message.split(",") && errorOrResult.message.split(",").length > 1) {
      dispatch(showNotification(errorOrResult.message.split(",")[1], "error"))
    } else {
      dispatch(showNotification(errorOrResult.message, "error"))
    }
    return errorOrResult;
  } else {
    dispatch(showNotification("SUCCESSFUL_SAVE", "success"))
  }

  dispatch(updateEmployeeSuccess(employee));

  return errorOrResult;
};
